module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'rzsnekyq',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
